import { ProgramTrialSubscriptionDto } from "@modules/common/trialSubscription/gateway/trialSubscriptionApiDto"

export class TrialSubscriptionEntity {
  startDate: Date
  endDate: Date

  constructor(trialSubscription: TrialSubscriptionEntity) {
    this.startDate = trialSubscription.startDate
    this.endDate = trialSubscription.endDate
  }

  static fromDto(trialSubscriptionDto: ProgramTrialSubscriptionDto): TrialSubscriptionEntity {
    return new TrialSubscriptionEntity({
      startDate:  new Date(trialSubscriptionDto.startDate),
      endDate:  new Date(trialSubscriptionDto.endDate),
    })
  }
}
